import { createWebHistory, createRouter } from "vue-router";
import redirect from "./redirect";
import masterData from "./masterData";
import account from "./account";
import guest from "./guest";
import artikel from "./artikel";
import konsultOnline from "./konsultOnline";
import ability from "@/plugins/casl/ability";
import { nextTick } from "vue";

const routes = [
    ...redirect,
    ...masterData,
    ...account,
    ...konsultOnline,
    ...guest,
    ...artikel,
    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("@/pages/home/Dashboard.vue"),
        meta: {
            pageTitle: "Dashboard",
            icon: "icon-[tabler--home]",
            layout: "LayoutBlank",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/home",
        name: "home",
        component: () => import("@/pages/home/HomeNew.vue"),
        meta: {
            pageTitle: "Beranda",
            icon: "icon-[tabler--home]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/gallery",
        name: "gallery",
        component: () => import("@/pages/gallery/Gallery.vue"),
        meta: {
            pageTitle: "Galeri",
            icon: "icon-[tabler--photo]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/tes-stres",
        name: "tesStres",
        component: () => import("@/pages/tes-stres/TesStres.vue"),
        meta: {
            pageTitle: "Tes Stres",
            icon: "icon-[tabler--photo]",
            layout: "LayoutUser",
            resource: "guest",
            action: "read",
        },
    },
    {
        path: "/hasil-tes-stres",
        name: "hasilTesKejiwaan",
        component: () =>
            import("@/pages/hasil-tes-kejiwaan/HasilTesKejiwaan.vue"),
        meta: {
            pageTitle: "Hasil Tes Stres",
            icon: "icon-[tabler--message-question]",
            layout: "LayoutUser",
            resource: "admin",
            action: "read",
        },
    },
];

const router = createRouter({
    // history: createWebHistory(import.meta.env.BASE_URL),
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (from.meta.savedPosition) {
            return savedPosition;
        } else {
            return { top: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    const hasLogin = ability.can("read", "auth");
    const canNavigate = to.matched.some((route) => {
        if (Array.isArray(route.meta.resource)) {
            let resource = route.meta.resource;
            const result = resource.some((r) => {
                return ability.can(route.meta.action || "read", r);
            });
            return result;
        } else {
            return ability.can(
                route.meta.action || "read",
                route.meta.resource
            );
        }
    });
    if (!canNavigate) {
        return next("/not-authorized");
    }
    if (hasLogin && to.name === "login") {
        next({ name: "home", replace: true });
        return;
    }
    next();
});

router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609

    nextTick().then(() => {
        // window.scrollTo(0, 0);
        document.title = to.meta.pageTitle + " - Mentari" || "Mentari";
    });
});

export default router;
